import { Box } from '@mui/material'
import { LoginState } from '../../../sharedComponents/src/globalHeader/GlobalHeader'
import { useStoreState } from '../../../store/hooks'
import { CycleRewardsBar } from '../components/CycleRewardsBar'
import { PuzzleQuestControls } from '../components/PuzzleQuestControls'
import { PuzzleQuestNavigation } from '../components/PuzzleQuestNavigation'
import { StatusHeader } from '../components/StatusHeader'
import { StepCooldown } from '../components/StepCooldown'

export const MobileCycleProgress = () => {
    const userState = useStoreState((state) => state.userData.state)
    const cycleProgress = useStoreState((state) => state.puzzleQuestView.cycleProgress)

    if (userState !== LoginState.LOGGED_IN || !cycleProgress) return null

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            <CycleRewardsBar
                rewardsTotal={cycleProgress.rewardsTotal}
                rewardsThreshold={cycleProgress.rewardsThreshold}
                season={cycleProgress.season}
                endTime={cycleProgress.endTime}
                rewards={cycleProgress.rewards}
            />
        </Box>
    )
}

export const MobilePQ = () => {
    const stepProgress = useStoreState((state) => state.puzzleQuestView.stepProgress)
    const currentPuzzleNumber = useStoreState((state) => state.puzzleQuestView.currentPuzzleNumber)

    return (
        <>
            {stepProgress.completed ? (
                <>
                    <StepCooldown />
                    <PuzzleQuestNavigation />
                </>
            ) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        paddingBottom: '16px',
                        h5: {
                            padding: '0 !important',
                            height: 'auto !important',
                        },
                    }}
                >
                    <StatusHeader />
                    <PuzzleQuestControls />
                    <MobileCycleProgress />
                </Box>
            )}
        </>
    )
}
